module.exports = __webpack_public_path__ + "img/logo.a2bd9ed3.png";